var _linearGradient, _path, _radialGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 612 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 396,
    x2: 396,
    y2: 456,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1F000A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#300454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066AB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M-178.2 0h792v456h-792z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 270.3,
    cy: 131.1,
    r: 55.5,
    gradientTransform: "matrix(.54495 .86127 -.87561 .53602 279.7 -231.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F1F7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3ACB1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M318 48.6c7.4-7 15.6-9.3 22.3-11.2 6.7-2 12.4-2.6 15.8-3a59.5 59.5 0 0 0-73.9-11 56.2 56.2 0 0 0-18.4 77.8 58.2 58.2 0 0 0 79.1 18.2A64 64 0 0 1 314 94c-3.6-6.2-9.4-16.2-6.8-28.1 2.1-9.2 8.2-15 10.9-17.4z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 217.2,
    x2: 217.2,
    y1: 110.9,
    y2: 263,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-101.2 253a31.9 31.9 0 0 1-24.2-36.8A32 32 0 0 1-88.2 191a21.4 21.4 0 0 1 41.6-9 45 45 0 0 1 33.4-52 23 23 0 0 1 20-19c11.2-1.1 22.1 7 24.4 19a39.8 39.8 0 0 1 44.6 12 39.4 39.4 0 0 1 5 39.5 31 31 0 0 1 32-14.5 31.1 31.1 0 0 1 25 26c.6-.3 14-7.6 27 0a27.3 27.3 0 0 1 13 27c5-6.7 13.2-8.9 19-6 6 3 8.4 12.3 6.6 18.8-7.2 25.2-83.6 28.2-83.6 28.2s-48.4 2.3-99 2c-47.8-.3-71.7-2.8-82-4a590.2 590.2 0 0 1-40-6z",
    opacity: 0.7
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 663.6,
    x2: 663.6,
    y1: 29.9,
    y2: 106,
    gradientTransform: "translate(-143.5 1.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M428.7 102.5c-11-2-17.8-10.2-15.8-18.4 2-8.5 13-14.2 24.3-12.6-.6-5.4 4.2-10.4 11-11.5 6.9-1.1 13.9 1.9 16.2 7-.4-1.5-2.1-9.1 4-16.5 6.2-7.2 15.7-9.1 17.7-9.5 1.2-5.2 6.7-9 13-9.5 7.3-.5 14.4 3.5 15.9 9.5 10.6-3 22.4-.5 29 6a16 16 0 0 1 3.4 19.7c4.3-5.5 12.7-8.4 20.9-7.2 8.4 1.2 15 6.4 16.3 13 .4-.2 9-3.8 17.6 0 6 2.7 9.4 8 8.5 13.5a12 12 0 0 1 12.4-3 7.6 7.6 0 0 1 4.3 9.4c-4.7 12.6-54.5 14-54.5 14s-31.6 1.3-64.6 1a546 546 0 0 1-79.6-5z",
    opacity: 0.8
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -2904.7,
    x2: -2904.7,
    y1: 55.9,
    y2: 122,
    gradientTransform: "matrix(-1.1403 0 0 1 -2934.5 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M440.4 117.6a14 14 0 0 0 10.8-16 14.2 14.2 0 0 0-16.6-10.9c.4-4.7-2.9-9-7.6-10a9.7 9.7 0 0 0-11 6.1 19 19 0 0 0-2.8-14.3c-4.2-6.3-10.7-7.9-12-8.3-.8-4.5-4.6-7.8-8.9-8.3-5-.5-9.9 3.1-10.9 8.3a18 18 0 0 0-19.9 5.2 16.7 16.7 0 0 0-2.2 17.2 14 14 0 0 0-14.3-6.3c-5.8 1-10.3 5.6-11.2 11.3-.3-.1-6.2-3.3-12 0a12 12 0 0 0-5.8 11.7c-2.2-2.9-5.9-3.9-8.5-2.6-2.6 1.3-3.8 5.3-2.9 8.2 3.2 10.9 37.3 12.2 37.3 12.2s21.6 1 44.2.9a337 337 0 0 0 36.6-1.7 326 326 0 0 0 17.7-2.7z",
    opacity: 0.9
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 248.5,
    x2: 248.5,
    y1: 327.6,
    y2: 383.6,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M5.3 379.9c-7.7-1.4-12.7-7.5-11.2-13.6 1.5-6.2 9.3-10.5 17.3-9.3-.5-4 3-7.7 8-8.5 4.8-.8 9.7 1.4 11.3 5.2a14 14 0 0 1 3-12.2c4.3-5.3 11-6.7 12.4-7 1-3.8 4.7-6.7 9.3-7 5.2-.4 10.2 2.6 11.3 7 7.6-2.2 16-.3 20.7 4.4 4 4 5 9.6 2.3 14.5 3.1-4.1 9-6.2 14.8-5.3 6 .9 10.7 4.7 11.6 9.6.3-.1 6.5-2.8 12.5 0 4.3 2 6.7 5.9 6 9.9a8.3 8.3 0 0 1 8.8-2.2 5.7 5.7 0 0 1 3 6.9c-3.3 9.3-38.7 10.4-38.7 10.4s-22.5.9-45.9.7a390 390 0 0 1-56.5-3.5z",
    opacity: 0.8
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 77,
    x2: 77,
    y1: 299.9,
    y2: 356,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M-166.2 352.3c-7.7-1.4-12.7-7.5-11.2-13.6 1.5-6.2 9.3-10.5 17.3-9.3-.5-4 3-7.7 8-8.5 4.8-.8 9.7 1.4 11.3 5.2a14 14 0 0 1 3-12.2c4.3-5.3 11-6.7 12.4-7 1-3.8 4.7-6.7 9.3-7 5.2-.4 10.2 2.6 11.3 7 7.6-2.2 16-.3 20.7 4.4 4 4 5 9.6 2.3 14.5 3.1-4.1 9-6.2 14.8-5.3 6 .9 10.7 4.7 11.6 9.6.3-.1 6.5-2.8 12.5 0 4.3 2 6.7 5.9 6 9.9a8.3 8.3 0 0 1 8.8-2.2 5.7 5.7 0 0 1 3 6.9c-3.3 9.3-38.7 10.4-38.7 10.4s-22.5.9-45.9.7a390 390 0 0 1-38-1.5c-7.6-.5-14-1.4-18.5-2z",
    opacity: 0.8
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 598.5,
    x2: 598.5,
    y1: 289,
    y2: 345,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M355.3 341.3c-7.7-1.4-12.7-7.5-11.2-13.6 1.5-6.2 9.3-10.5 17.3-9.3-.5-4 3-7.7 8-8.5 4.8-.8 9.7 1.4 11.3 5.2a14 14 0 0 1 3-12.2c4.3-5.3 11-6.7 12.4-7 1-3.8 4.7-6.7 9.3-7 5.2-.4 10.2 2.6 11.3 7 7.6-2.2 16-.3 20.7 4.4 4 4 5 9.6 2.3 14.5 3.1-4.1 9-6.2 14.8-5.3 6 .9 10.7 4.7 11.6 9.6.3-.1 6.5-2.8 12.5 0 4.3 2 6.7 5.9 6 9.9a8.3 8.3 0 0 1 8.8-2.2 5.7 5.7 0 0 1 3 6.9c-3.3 9.3-38.7 10.4-38.7 10.4s-22.5.9-45.9.7a390 390 0 0 1-56.5-3.5z",
    opacity: 0.8
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 532.9,
    x2: 532.9,
    y1: 293.3,
    y2: 369.4,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M258.8 364.4c-11.4-1.9-18.7-10.2-16.6-18.4 2.2-8.5 13.7-14.2 25.5-12.6-.7-5.4 4.4-10.4 11.6-11.5 7.2-1.1 14.4 1.9 17 7-.5-1.5-2.3-9.1 4.3-16.5 6.4-7.2 16.4-9.1 18.5-9.5 1.3-5.2 7-9 13.7-9.5 7.7-.5 15.1 3.5 16.7 9.5 11.2-2.9 23.5-.5 30.5 6a15.6 15.6 0 0 1 3.4 19.8c4.6-5.5 13.3-8.4 22-7.2 8.8 1.2 15.7 6.4 17 13a26 26 0 0 1 18.5 0c6.3 2.7 9.8 8 9 13.5a13 13 0 0 1 13-3 7.5 7.5 0 0 1 4.4 9.4c-4.9 12.6-57 14.1-57.2 14.1 0 0-33 1.2-67.7 1a705 705 0 0 1-56-2 766.4 766.4 0 0 1-27.6-3.1z",
    opacity: 0.8
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -2980.2,
    x2: -2980.2,
    y1: 288,
    y2: 488.4,
    gradientTransform: "matrix(-1 0 0 1 -2762.4 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#412267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160B45"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m613.8 379.6-10.7-12.8c.1 1 1 12.2-5 20.1a13.6 13.6 0 0 1-13.5 5.7c-2 .2-14.7 1.3-23.7-11.5-3.5-5-5.3-10.5-6.2-14.3l-16.5 12.9a369.8 369.8 0 0 0-57.6-60.2 305 305 0 0 0-46.3-31.5c-5 12.7-18.5 42.4-45.2 63a90.5 90.5 0 0 1-59.6 20.1 29.6 29.6 0 0 1-14.4-11.5 39.4 39.4 0 0 1-5-10c-8.5 12.9-22.2 31-42.3 45.8-24 17.8-75.9 27.1-82.3 20.1a39.6 39.6 0 0 1-8.2-25.8l-24.7 30.1a250.6 250.6 0 0 0-47.3-41.5A209 209 0 0 0 57 354c-11.8 12.5-48 48.7-91.5 55.9-19.7 3.3-42 10.5-52.4-7.2-8-13.7-5-34.9-3-44.4a372 372 0 0 0-65.9 61.6c-5.9-1.8-22-12.7-22-12.7l-.4 81.2 792-4.2"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 396,
    x2: 396,
    y1: 327,
    y2: 467,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#372871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190020"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M-178.2 392.3-166 382c0 .7-1 8.5 5 14 5.4 4.9 12.1 4.1 13 4 2.1.2 14.3.9 23-8a26 26 0 0 0 6-10l16 9A315.3 315.3 0 0 1-2 327a113.3 113.3 0 0 0 102 58 29.7 29.7 0 0 0 19-15c8.1 9 21.5 21.6 41 32 23.3 12.4 73.8 19 80 14 8.3-6.7 8-16.9 8-18l24 21a242.4 242.4 0 0 1 93-46c11.5 8.7 46.8 34 89 39 19.2 2.3 41 7.4 51-5 7.8-9.6 4.8-24.3 3-31a347.5 347.5 0 0 1 64 43 63.8 63.8 0 0 0 21.4-8.9c8.4-5.5 20.5-10.2 20.6-10.4V467l-792-3"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 396,
    x2: 396,
    y1: 392.9,
    y2: 555.4,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M-177.7 418c19.2-8.6 43.3-17 71.5-21.6 80.5-13.2 135.5 14 225 35.7 42.3 10.2 100.2 15.8 216 27 123 11.9 279 20.6 279 20.6v38.4s-779.3 34.2-792 37.4l.5-137.5z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 396.3,
    x2: 396.3,
    y1: 445.9,
    y2: 578.6,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M-177.7 452.9c70 20.9 191.2 53.6 334 24.1 15.1-3.1 10-2.6 37-9 131.5-31.1 420.5-20.3 420.5-20.3v95.8c0-.7-537.3 103.9-790.3-44.6-1.6-33.2-.2-3.2-1-39.9 0-1.8 0-3.9-.2-6.1z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 396.5,
    x2: 396.5,
    y1: 500.7,
    y2: 612,
    gradientTransform: "translate(-178.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M613.8 500.7a3308.6 3308.6 0 0 1-791 0v111.4h791z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 4.5,
    d: "m349.5 163.8-2.3-1.1-2.3 1.3.4-2.6-2-1.8 2.6-.4 1-2.4 1.3 2.3 2.6.3-1.8 1.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 3.1,
    d: "m508.7 150.8-1.8-1-1.9 1 .4-2-1.5-1.5 2-.3 1-1.9.9 1.9 2 .3-1.5 1.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 3.5,
    d: "m152.4 44.6-3.5-1.3-3.2 2.2.2-3.8-3-2.3 3.6-1 1.2-3.7 2.1 3.2h3.9l-2.4 3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 8.1,
    d: "M240.8 277.6v-.7l-.7-.3.6-.4.2-.7.5.5.7-.1-.3.7.3.6-.7-.1zm97.7-55.7-3-5-5.6-.3 3.8-4.3-1.4-5.6 5.2 2.3 4.8-3-.5 5.7 4.4 3.6-5.6 1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 6.4,
    d: "m168 197.9-4.8-3.6-5.7 2 2-5.7-3.6-4.8h6l3.4-4.8 1.8 5.7 5.7 1.8-5 3.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 4.6,
    d: "m92.1 119.2-9-2.8-7.5 5.8-.1-9.4-7.9-5.3 9-3 2.6-9.2 5.6 7.6 9.5-.3-5.5 7.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 4.5,
    d: "M20 73.8 17.7 72l-2.8.8L16 70l-1.6-2.5 3 .2 1.7-2.2.7 2.8 2.8 1L20 71z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 2.9,
    d: "m560.5 221.5-.9-2.1-2.2-.5 1.7-1.5-.2-2.3 2 1.2 2-1-.5 2.3 1.5 1.7-2.3.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 8.1,
    d: "m596.8 35.3-5.8-1-4 4.4-1-5.9-5.3-2.5 5.2-2.7.8-5.8 4.2 4.1 5.8-1L594 30z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 6.1,
    d: "m-17.5 326.9-1.3-2.2h-2.6l1.7-2-.7-2.4 2.3.9 2.1-1.4-.1 2.5 2 1.6-2.5.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecff00",
    stroke: "#fffb00",
    strokeWidth: 4.7,
    d: "m264.9 182-4.1-3-4.8 1.7 1.6-4.9-3-4h5l3-4.2 1.5 5 4.9 1.4-4.2 3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH0);
export default __webpack_public_path__ + "static/media/h0.fda25dd8380d3bab69e4651812fab850.svg";
export { ForwardRef as ReactComponent };